var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEliminatePaperZap({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2195_4660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2934 7.72728L10.8282 34.2772L28.653 31.7721L28.8993 47.8947L45.3645 21.3448L27.5396 23.8499L27.2934 7.72728Z",
    stroke: "#3571D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2195_4660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.989746 7.38477) rotate(-8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEliminatePaperZap);
export default __webpack_public_path__ + "static/media/eliminate-paper-zap.ea06bb9c8b17873fcaf0feff33f0ed09.svg";
export { ForwardRef as ReactComponent };